var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumb-element"},[_c('div',{staticClass:"text"},[_c('LocalizedLink',{staticClass:"text",attrs:{"to":""}},[_vm._v("e-City Toolbox /")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }